module.exports = __webpack_public_path__ + "web/img/sign-60.e6e968a7.png";